/*
 * cart-qty-remove.js
 * When the quantity "minus" button is clicked at the minimum quantity inside a
 * cart context (mini cart drawer or cart page), remove the line entirely instead
 * of the default no-op clamp. Scoped to cart lines only — PDP quantity selectors
 * (inside <xo-product-variant>) are left untouched.
 *
 * Implemented as a capture-phase listener so it runs before the web component's
 * own click handler; stopImmediatePropagation() suppresses the default decrement.
 */
(function () {
  document.addEventListener(
    'click',
    function (event) {
      var target = event.target;
      if (!target || !target.closest) return;

      var minus = target.closest('xo-cart-quantity-minus');
      if (!minus) return;

      // Leave product-page (add-to-cart) quantity selectors alone.
      if (minus.closest('xo-product-variant')) return;

      var quantityEl = minus.closest('xo-cart-quantity');
      if (!quantityEl) return;

      var input =
        quantityEl.querySelector('input.xo-quantity__number') ||
        quantityEl.querySelector('input[name="quantity"]');
      if (!input) return;

      var min = Number(quantityEl.getAttribute('xo-min') || '1');
      var current = Number(input.value);
      if (!Number.isFinite(current)) return;

      // Above the minimum: let the normal decrement happen.
      if (current > min) return;

      // At (or below) the minimum: remove the line instead.
      var line = minus.closest('.xo-cart-mini-item, .xo-cart-item');
      var remove = line && line.querySelector('xo-cart-remove');
      if (!remove) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      remove.click();
    },
    true // capture
  );
})();
